// @ai-generated 2026-07-21T06:16:43Z by malte.ulfers@tngtech.com using Claude Opus 4.7 (1M context)
import { FEATURE_FLAGS } from '@Constants/featureFlagConstants';
import { type SidebarLinkProp } from '@synqo/frontend-component-library';
import { TablerIcon } from '@tabler/icons-react';

/**
 * A sidebar entry. Either a {@link MenuGroup} that expands to reveal nested
 * {@link MenuElementTarget}s, or a {@link MenuLeaf} that navigates directly.
 */
export type MenuElement = MenuGroup | MenuLeaf;

interface MenuElementBase {
    name: string;
    label: string;
    icon?: TablerIcon;
}

export interface MenuGroup extends MenuElementBase {
    kind: 'group';
    initiallyOpened?: boolean;
    targets: MenuElementTarget[];
}

export interface MenuLeaf extends MenuElementBase {
    kind: 'leaf';
    link: string;
    permissions: string[];
    featureFlag?: keyof typeof FEATURE_FLAGS;
}

export interface MenuElementTarget extends SidebarLinkProp {
    permissions: string[];
    featureFlag?: keyof typeof FEATURE_FLAGS;
}

export function isMenuGroup(element: MenuElement): element is MenuGroup {
    return element.kind === 'group';
}

export function isMenuLeaf(element: MenuElement): element is MenuLeaf {
    return element.kind === 'leaf';
}
